<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						修改用户
					</div>
					<div style="padding: 30px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="所属软件" prop="software">
								<el-input type="text" size="small" v-model="ruleForm.software"
									style="width: 300px;" disabled></el-input>
							</el-form-item>
							<el-form-item label="账号" prop="username">
								<el-input type="text" disabled placeholder="请输入账号" size="small" v-model="ruleForm.username"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="password">
								<el-input type="text" placeholder="请输入密码" size="small" v-model="ruleForm.password"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="允许多端数量" prop="max_num">
								<el-input-number size="small" v-model="ruleForm.max_num" controls-position="right"
									:min="0" :max="999"></el-input-number>
							</el-form-item>

							<el-form-item label="到期时间" prop="endtime">
								<el-date-picker size="small" v-model="ruleForm.endtime" type="datetime"
									placeholder="选择到期时间" style="width: 300px;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="配置">
								<div slot="label" style="display: flex;align-items: center;">
									<span>配置</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(0)">
								</div>
								<el-input type="text" placeholder="请输入配置" size="small" v-model="ruleForm.config"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="冻结状态">
								<el-radio-group v-model="ruleForm.status">
									<el-radio :label="2">冻结</el-radio>
									<el-radio :label="1">解冻</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">确认修改</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						登录日志
					</div>
					<div style="padding: 30px;">
						<div v-if="list.length>0">
							<div class="t-header">
								<div class="t-item">
									登录时间
								</div>
								<div class="t-item">
									登录IP
								</div>
								<div class="t-item">
									识别码
								</div>
							</div>
							<div class="t-body" v-for="(item,index) in list" :key="index">
								<div class="t-item">
									<span v-if="item.datetime">{{item.datetime.slice(-14)}}</span>
								</div>
								<div class="t-item">
									{{item.ip}}
								</div>
								<div class="t-item">
									{{item.needle}}
								</div>
							</div>
						</div>
						<div style="font-size: 14px;margin-top: 10px;display: flex;align-items: center;justify-content: center;color:#ccc">
							登录历史只保留最近30条，并且会定时清理
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				dialogCodeVisible:false,
				msg:'',
				msg_list:[
					'卡密配置的作用请查看帮助，没有用到请忽略',
				],
				list:[],
				ruleForm: {
					username: '',
					password: '',
					one: '',
					endtime: '',
					max_num: '',
					software: '',
					config: '',
				},
				rules: {
					software: [{
						required: true,
						message: '请选择所属软件',
						trigger: 'change'
					}],
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					max_num: [{
						required: true,
						message: '请输入允许多端数量',
						trigger: 'blur'
					}],
					endtime: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'change'
					}],
					config: [{
						required: true,
						message: '请输入配置',
						trigger: 'blur'
					}],
				},
				type_config: {},
				software_list: [],
				card_state_conf: {},
			}
		},
		props:{
			username:String
		},
		created() {
			this.resetForm()
			this.getData()
		},
		methods: {
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			getData() {
				this.$H.post('verify_center/v1_0_1.User/Info',{
					username:this.username
				}).then(res => {
					if(!res.data) return;
					res.data.endtime = this.formatTime(res.data.endtime)
					this.ruleForm = res.data;
					let status = 1
					if(res.data.status>1){
						status = 2
					}
					if(res.data.status<2){
						status = 1
					}
					this.list = res.data.login_log
				});
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var data = {
							max_num:this.ruleForm.max_num,
							config:this.ruleForm.config,
							one:this.ruleForm.one,
							password:this.ruleForm.password,
							status:this.ruleForm.status,
							username:this.ruleForm.username,
							endtime:this.ruleForm.endtime
						}
						this.$H.post('verify_center/v1_0_1.User/Edit', data).then(res => {
							if(!res.data) return;
							this.$message.success('修改成功')
							this.$emit('back')
						}).catch(err => {
							console.log(err)
							this.$emit('back')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
	.t-header {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}
	
	.t-body {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}
	
	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>